import { inject, injectable } from 'inversify';
import * as esCookies from 'es-cookie';
import { CookieAttributes } from 'es-cookie';
import domain from '@framework/config/domain';
import cookieConfig from '@framework/config/cookie';
import isServer from '@framework/router/Next/isServer';
import Container from '@framework/di/Container';
import ClientCookie, { ICookies } from '@framework/router/Next/cookie/ClientCookie';

const cookies = { ...esCookies };

@injectable()
class CookieRepository {
  private serverCookieString: string = '';

  constructor(@inject(Container) private readonly container: Container) {}

  set(key: string, value: string, attributes: CookieAttributes = {}): string | void {
    if (isServer()) {
      this.serverCookieString = cookies.encode(key, value, { path: '/', ...attributes });
      return this.serverCookieString;
    }
    return cookies.set(key, value, {
      domain: `.${ domain.finsightDomain }`,
      ...attributes,
      secure: cookieConfig.secure || undefined,
    } as CookieAttributes);
  }

  async get(key: string): Promise<string | undefined> {
    if (isServer()) {
      const clientCookie = await this.container.getAsync(ClientCookie);
      return clientCookie.cookie[key];
    }
    return cookies.get(key);
  }

  async getAll(): Promise<ICookies> {
    if (isServer()) {
      const clientCookie = await this.container.getAsync(ClientCookie);
      return clientCookie.cookie;
    }
    return cookies.getAll();
  }

  remove(key: string, attributes: CookieAttributes = {}): void {
    cookies.remove(key, {
      ...attributes,
      domain: `.${ domain.finsightDomain }`,
    });
  }

  removeFromCurrentDomain(key: string): void {
    cookies.remove(key);
  }
}

export default CookieRepository;
